import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import environmentConfig from "../../../../environmentConfig";
import { userInTeams } from "../../../../tools/teams/teamsService";
import { AccountCompany } from "../AccountCompany/AccountCompany";
import styles from "./AccountMenu.module.scss";
import { AccountMenuDropdown } from "./AccountMenuDropdown/AccountMenuDropdown";
import { AccountMenuItem } from "./AccountMenuItem/AccountMenuItem";
import { selectCurrentProfile } from "features/Account/redux/profile/profileSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";

interface Props {
  onSignout: () => void;
}

export const AccountMenu: React.FC<Props> = ({ onSignout }) => {
  const { t } = useTranslation(["account"]);
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);
  const showLanguagePage: boolean = process.env.NODE_ENV !== "production";
  const profile = useSelector(selectCurrentProfile);

  const handleNavigateToProfile = useCallback(() => {
    navigate("/profile");
    setOpened(false);
  }, [navigate]);

  const handleNavigateToLang = useCallback(() => {
    navigate("/lang");
    setOpened(false);
  }, [navigate]);

  const handleNavigateToHistory = useCallback(() => {
    navigate("/profile/history");
    setOpened(false);
  }, [navigate]);

  const handleNavigateToAdminPortal = useCallback(() => {
    window.open(environmentConfig.apUrl, "_blank");
    setOpened(false);
  }, []);

  const handleSignOut = useCallback(() => {
    onSignout();
  }, [onSignout]);

  return (
    <div className={styles.root}>
      <AccountMenuDropdown opened={opened} setOpened={setOpened}>
        <div className={styles.menu}>
          <section className={styles.company}>
            <AccountCompany />
          </section>
          {!userInTeams() && (
            <section className={styles.menufirst}>
              <AccountMenuItem
                active
                iconClass="user circle"
                onClick={handleNavigateToProfile}
                text={t("menu.myProfile")}
              />

              {showLanguagePage && (
                <AccountMenuItem
                  active
                  iconClass="language"
                  onClick={handleNavigateToLang}
                  text={t("menu.switchLang")}
                />
              )}
              <AccountMenuItem
                active
                iconClass="history"
                onClick={handleNavigateToHistory}
                text={t("menu.myHistory")}
              />
            </section>
          )}
          <section className={styles.menusecond}>
            {profile?.hasAdminPermission && (
              <AccountMenuItem
                active
                icon={<FontAwesomeIcon icon={faUpRightFromSquare} />}
                onClick={handleNavigateToAdminPortal}
                text={t("menu.adminPortal", "Admin Portal")}
              />
            )}
            <AccountMenuItem active iconClass="sign out" onClick={handleSignOut} text={t("menu.logOut")} />
          </section>
        </div>
      </AccountMenuDropdown>
    </div>
  );
};
